import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { faCogs, faPlugCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { MapInfoWindow } from "@angular/google-maps";
import { timeout } from "../../../decorators/timeout";
import { Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Observable, take } from "rxjs";
import { faFirefox } from "@fortawesome/free-brands-svg-icons";
import { SceneCreateWizardComponent } from "../scene-create-wizard/scene-create-wizard.component";
import { AiSceneWizardComponent } from "../ai-scene-wizard/ai-scene-wizard.component";
import { Compbaser } from "../../../components/compbaser";
import { SceneMimeTypes } from "../scene-blocks/mime-constants";
import { DialogSceneCardBrowserComponent } from "../../../components/dialog-scene-card-browser/dialog-scene-card-browser.component";
import { DialogPopComponent } from "../../../components/dialog-pop/dialog-pop.component";
import { IDialogGetAsset } from "../../../components/dialog-get-asset/dialog-get-asset.component";
import { DialogClipboardComponent } from "../../../components/dialog-clipboard/dialog-clipboard.component";
import { SceneCardTemplateService } from "../../../services/scene-card-template.service";
import {
    EnumWizardUpgradeToasts,
    ExperienceLevelType,
    IAccessTable,
    ICommon,
    ICRUDCommand,
    ICRUDRecord,
    Id,
    IPage,
    IPager,
    IPlayerProps,
    ISceneBlock,
    ISceneTreeSearchResult,
    ISceneTreeSliceResults,
    IStationData,
    IUser,
} from "../../../interfaces";
import {
    getPlayerIdInScene,
    getPlayerIdsOfSceneId,
    isMimeTypeExists,
    isSceneEmbedded,
    isMainTouchScene,
    LargePageSizeOptions,
    preprocessSceneRecord,
    preProcessSceneTree,
    PREVIOUSLY_USED_ACCOUNT,
    isGalaxy,
    isHostDevOrLocal,
    isTruthy,
} from "../../../common";
import {
    actionAddScene,
    actionAddSceneItem,
    actionCRUDRecord,
    actionRemoveSceneBlocks,
    actionRemoveScenes,
    actionSelectedSceneId,
    actionSelectedSceneTouchId,
    actionUpdateSceneItem,
    actionAddScheduleItem,
    actionAddScheduleEvent,
    actionUpdateScenePlayer,
} from "../../../store/actions/user.actions";
import { AccessService, AppService, CommonService, ContainerService, ImportService, LocalStoreService, StoreSelectorsService } from "../../../services";
import { MatTabChangeEvent } from "@angular/material/tabs";
import * as _ from "lodash";
import { Lib } from "../../../../libs/Lib";
import { SceneListService } from "../../../services/scene-list.service";
import { TouchLib } from "../touch/touchLib";
import { Memoizee } from "../../../decorators/memoizee-decorator";

enum EnumConnectionType {
    ALL,
    REGULAR,
    SPECIALIZED,
    SLIDES,
}

const ConnectionTypeIcons = {
    [EnumConnectionType.ALL]: "apps",
    [EnumConnectionType.REGULAR]: "web",
    [EnumConnectionType.SPECIALIZED]: "apps",
    [EnumConnectionType.SLIDES]: "slideshow",
};

@Component({
    selector: "app-scene-list-details",
    templateUrl: "./scene-list-details.component.html",
    styleUrls: ["./scene-list-details.component.scss"],
    standalone: false,
})
export class SceneListDetailsComponent extends Compbaser implements OnInit, AfterViewChecked {
    @ViewChild("addBlackScene", { read: TemplateRef }) addBlackScene: TemplateRef<any>;
    @ViewChild("addSliderModal", { read: TemplateRef }) addSliderModal: TemplateRef<any>;
    @ViewChild("firefoxModal", { read: TemplateRef }) firefoxModal: TemplateRef<any>;
    @ViewChild("createSceneModal", { read: TemplateRef }) createSceneModal: TemplateRef<any>;
    @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    @Input() dialogGetAsset: IDialogGetAsset;

    @Input()
    set filterByType(i_value: boolean) {
        this.m_filterByType = i_value;
    }

    @Output() itemSelected = new EventEmitter<number>();
    @Output() toggleMinimize = new EventEmitter<any>();
    @Output() btnClick = new EventEmitter();

    readonly faFirefox = faFirefox;
    readonly pageSizeOptions = LargePageSizeOptions;
    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    m_stations: Array<IStationData>;
    pageSize = 10;
    pageIndex = 0;
    hidePageSize = false;
    selectedTabIndex = 0;
    allowMultiSelect = true;
    highlightedRows = [];
    m_EnumConnectionType = EnumConnectionType;
    m_ConnectionTypeIcons = ConnectionTypeIcons;
    m_EnumConnectionSelected = EnumConnectionType.ALL;
    globalFilter = "";
    showFavoritesOnly = false;
    columnFilter = {
        tree_path: "",
    };
    faPlugCircleCheck = faPlugCircleCheck;
    faCogs = faCogs;
    categories: Array<string> = [];
    m_filterByType: boolean;
    dataSource: MatTableDataSource<any>;
    displayedColumns: string[] = [];
    isMobileView = false;

    private readonly fullColumns = ["select", "favorite", "thumbnail", "label", "id", "dimensions", "modified", "type", "items", "category", "playerAssignable"];
    private readonly mediumColumns = ["select", "favorite", "thumbnail", "label", "dimensions", "modified", "type"];
    private readonly mobileColumns = ["favorite", "thumbnail", "label"];
    selection: SelectionModel<string>;
    exclusiveMimeType: string; // filter by specific mime type
    sceneId: Id;
    sceneItemId: Id;
    markedRowId: Id;
    activeSort;
    isFullFeatures;
    scenes: IPlayerProps[] = [];
    lastGetTime;
    activeModal;
    newSceneSettings = { width: 1920, height: 1080, name: "new scene", slideCount: 3 };
    accountInitialCopyResources;
    PREVIOUSLY_USED_ACCOUNT = PREVIOUSLY_USED_ACCOUNT;
    groupsAccessTable$: Observable<IAccessTable>;
    stringJSPipeArgs = { toDateFromTimestamp: ["MM/DD/YY H:mm"] };
    stringJSPipeJson = { replace: ["Json.", ""] };
    stringJSPipeJson2 = { replace: [".", " "] };
    dataSourcePreviewList$: BehaviorSubject<any[]>;
    m_user: IUser;
    loading: any = false;
    isDev = false;

    constructor(
        public storeSelector: StoreSelectorsService,
        public router: Router,
        protected override dialog: MatDialog,
        public cdr: ChangeDetectorRef,
        private accessService: AccessService,
        private localStoreService: LocalStoreService,
        private translocoService: TranslocoService,
        private toastr: ToastrService,
        private sceneListService: SceneListService,
        private containerService: ContainerService,
        private commonService: CommonService,
        private importService: ImportService,
        private appService: AppService,
        private sceneCardTemplateService: SceneCardTemplateService,
    ) {
        super();
        this.updateDisplayedColumns();
    }

    @HostListener("window:resize")
    onWindowResize() {
        this.updateDisplayedColumns();
    }

    private updateDisplayedColumns() {
        const width = window.innerWidth;
        let columns: string[];
        if (width < 768) {
            columns = [...this.mobileColumns];
            this.isMobileView = true;
        } else if (width < 1280) {
            columns = [...this.mediumColumns];
            this.isMobileView = false;
        } else {
            columns = [...this.fullColumns];
            this.isMobileView = false;
        }
        if (this.dialogGetAsset && !this.dialogGetAsset.multiSelect) {
            const selectIdx = columns.indexOf("select");
            if (selectIdx > -1) columns.splice(selectIdx, 1);
        }
        this.displayedColumns = columns;
    }

    ngOnInit() {
        const initialSelection = [];
        this.groupsAccessTable$ = this.accessService.getGroupsTable("SignStudio Editor", "player_data");
        this.pageSize = parseInt(this.localStoreService.getStorageValConfig("pageSize")) || 10;
        this.globalFilter = this.localStoreService.getStorageValConfig("sceneFilter");
        this.columnFilter.tree_path = this.localStoreService.getStorageValConfig("sceneCategory");
        this.showFavoritesOnly = this.localStoreService.getStorageValConfig("sceneFavoritesOnly") === "true";
        this.accountInitialCopyResources = this.localStoreService.getStorageConfig().accountInitialCopyResources;

        if (this.dialogGetAsset) {
            this.allowMultiSelect = this.dialogGetAsset.multiSelect;
            this.updateDisplayedColumns();
            this.exclusiveMimeType = this.dialogGetAsset.mimeType;
            if (_.isEmpty(this.exclusiveMimeType)) {
                this.m_EnumConnectionSelected = EnumConnectionType.ALL;
            }
        }
        this.selection = new SelectionModel<string>(this.allowMultiSelect, initialSelection);
        this.isDev = isHostDevOrLocal();
        this.cod(
            this.storeSelector.getUser().subscribe((user: IUser) => {
                this.m_user = user;
            }),
        );
        this.cod(
            this.storeSelector.getLastGetTime().subscribe((v) => {
                this.lastGetTime = v;
            }),
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            }),
        );
        this.cod(
            this.storeSelector.listenSelectedSceneIdAndSceneItemId().subscribe((v) => {
                this.sceneId = v.sceneId;
                this.sceneItemId = v.sceneItemId;
            }),
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates().subscribe((updates) => {
                this.experienceLevel = this.localStoreService.getStorageValConfig("experienceLevel"); // Alon
                if (!updates) return;
                this.accountInitialCopyResources = this.localStoreService.getStorageValConfig("accountInitialCopyResources");
                setTimeout(() => {
                    if (this.accountInitialCopyResources == PREVIOUSLY_USED_ACCOUNT) {
                        if (this.dataSource && this.sort && this.paginator) {
                            this.dataSource.sort = this.sort;
                            this.dataSource.paginator = this.paginator;
                            this.cdr.detectChanges();
                        }
                    }
                }, 100);
            }),
        );
        this.cod(
            this.containerService.getMarkedTableRow().subscribe((_id) => {
                if (_id) this.markedRowId = _id;
                setTimeout(() => {
                    this.markedRowId = "";
                }, 500);
            }),
        );
        this.resetTableSelection();
        this.updateDataSource();

        // this.cod(
        //     this.storeSelector.isFirefox().subscribe((v) => {
        //         if (!v) return;
        //         setTimeout(() => {
        //             this.dialog.open(this.firefoxModal, {
        //                 width: '400px',
        //                 height: '300px'
        //             });
        //         }, 3000);
        //     })
        // );
        this.cod(
            this.storeSelector.getStationsComplete().subscribe((v) => {
                this.m_stations = v || [];
            }),
        );

        this.cod(
            this.sceneListService.selectedChanged$.subscribe((sceneIds) => {
                this.clearSelection();
                this.selection.clear();
                this.selection.select(...(sceneIds as string[]));

                this.sort.active = "select";
                this.sort.direction = "desc";
                this.sort.sortChange.emit({ active: this.sort.active, direction: this.sort.direction });
            }),
        );

        this.cod(
            this.sceneListService.deleteSelected$.subscribe((sceneIds) => {
                this.onDelete();
            }),
        );
    }

    ngAfterViewChecked(): void {}

    private resetTableSelection() {
        const tblSelection = this.containerService.getTableSelection("scenes");
        if (tblSelection) {
            // reset table pagination
            if (tblSelection["pageIndex"]) this.pageIndex = tblSelection["pageIndex"];

            // reset table sort
            if (tblSelection["sort"]) {
                this.activeSort = tblSelection["sort"];
            }

            // reset selection model
            // if (tblSelection['selectedModel'] && tblSelection['selectedModel'].length > 0) {
            //     this.selection.clear();
            //     setTimeout(() => {
            //         tblSelection['selectedModel'].forEach((s) => {
            //             this.selection.select(s);
            //         });
            //     }, 500);
            // }
        }
    }

    onFilterSelection(e) {
        this.selection.clear();
        this.m_EnumConnectionSelected = e.value;
        this.updateDataSource();
    }

    onFilterByCard(filterType: EnumConnectionType) {
        this.selection.clear();
        this.m_EnumConnectionSelected = filterType;
        this.updateDataSource();
    }

    onViewToggleChange(tabIndex: number) {
        this.selectedTabIndex = tabIndex;
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        if (this.dataSource) {
            const numSelected = this.selection.selected.length;
            const pageSize = this.dataSource.paginator.pageSize;
            if (numSelected >= pageSize) {
                return true;
            } else {
                if (this.dataSource.filteredData.length > pageSize) {
                    return false;
                } else {
                    return this.dataSource.filteredData.length === numSelected;
                }
            }
        }
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        if (!this.dataSource) return;
        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            const pageIndex = this.dataSource.paginator.pageIndex;
            const pageSize = this.dataSource.paginator.pageSize;
            let endIndex: number;
            if (this.dataSource.filteredData.length > (pageIndex + 1) * pageSize) {
                endIndex = (pageIndex + 1) * pageSize;
            } else {
                endIndex = this.dataSource.filteredData.length;
            }

            for (let index = pageIndex * pageSize; index < endIndex; index++) {
                this.selection.select(this.dataSource.filteredData[index].Player.$.id as any);
            }
        }
    }

    onDeselect() {
        this.selection.clear();
    }

    @timeout(10)
    updateDataSource() {
        let source: Array<IPlayerProps> = [];
        this.getSceneCategories();
        this.cod(
            this.storeSelector.getScenes(true, false).subscribe((i_scenes) => {
                // const sortedByModified = i_scenes.sort((a, b) => {
                //     if (b.Player.$.lastModified) {
                //         if (a.Player.$.lastModified && b.Player.$.lastModified) {
                //             return parseInt(b.Player.$.lastModified) - parseInt(a.Player.$.lastModified);
                //         }
                //         return 1;
                //     }
                //     return -1;
                // });

                this.scenes = i_scenes;
                source = i_scenes.filter((i_scene) => {
                    if (i_scene.Player.$.id === this.sceneId) {
                        return this.dialogGetAsset.includeSelf;
                        // if (isSceneDesktopEmpty(i_scene))
                        //     return false;
                    }

                    switch (this.m_EnumConnectionSelected) {
                        case EnumConnectionType.ALL: {
                            return true;
                        }
                        case EnumConnectionType.REGULAR: {
                            return (this.storeSelector.isMainSceneOrPlayer(i_scene.Player.$.mimeType) || i_scene.Player.$.mimeType.length === 0) && !isMainTouchScene(i_scene);
                        }
                        case EnumConnectionType.SPECIALIZED: {
                            return (
                                i_scene.Player?.$?.mimeType?.length > 0 &&
                                i_scene.Player.$.mimeType !== SceneMimeTypes.Player &&
                                i_scene.Player.$.mimeType !== SceneMimeTypes.Scene &&
                                i_scene.Player.$.mimeType !== SceneMimeTypes.Slides
                            );
                        }
                        case EnumConnectionType.SLIDES: {
                            return isMainTouchScene(i_scene);
                        }
                    }
                });

                /**
                     if we want to filter the scenes by an additional passed in to dialog mimeType, if the passed in is of 'scene' or 'mainPlayer'
                     we check against both possibilities to know if to show the scene in the list or not, if it's not 'scene' or 'mainPlayer' that
                     was passed in, we just use standard findIndex to filter by a match.
                     **/
                if (this.exclusiveMimeType) {
                    // const blockLabelProp: IBlockLabelProp = this.storeSelector.getBlockLabelByJsonType(this.exclusiveMimeType);
                    source = source.filter((value) => {
                        if (this.storeSelector.isMainSceneOrPlayer(this.exclusiveMimeType)) {
                            switch (this.dialogGetAsset.mode) {
                                case "SCENE:PLAYER_ASSIGNABLE": {
                                    return this.storeSelector.isMainScenePlayerOnly(value.Player.$.mimeType);
                                }
                                default: {
                                    return this.storeSelector.isMainSceneOrPlayer(value.Player.$.mimeType);
                                }
                            }
                        } else {
                            return isMimeTypeExists([this.exclusiveMimeType], value.Player.$.mimeType);
                        }
                    });
                }

                // Sort by lastModified (most recent first)
                source = source.sort((a, b) => {
                    const aModified = a.Player.$.lastModified ? parseInt(a.Player.$.lastModified) : 0;
                    const bModified = b.Player.$.lastModified ? parseInt(b.Player.$.lastModified) : 0;
                    return bModified - aModified;
                });

                this.applyTableCustomization(source);
                if (this.globalFilter || this.columnFilter.tree_path || this.showFavoritesOnly) this.applyFilter(this.globalFilter);
            }),
        );
    }

    onCategoryChange(val) {
        this.columnFilter.tree_path = val ? val : "";
        this.localStoreService.setStorageValConfig("sceneCategory", this.columnFilter.tree_path);
        if (this.dataSource) this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    applyFilter(filterValue: string) {
        this.localStoreService.setStorageValConfig("sceneFilter", filterValue);
        if (this.dataSource) this.dataSource.filter = JSON.stringify(this.columnFilter);
    }

    applyTableCustomization(sources) {
        this.dataSource = new MatTableDataSource(sources);
        this.dataSource.paginator = this.paginator;

        this.dataSource.filterPredicate = this.customFilterPredicate();
        // this.dataSource.filterPredicate = (data: any, filter) => {
        //     const dataStr = JSON.stringify(data).toLowerCase();
        //     return dataStr.indexOf(filter) !== -1;
        // };

        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item: IPlayerProps, property) => {
            switch (property) {
                case "favorite":
                    return isTruthy(item.Player.$.favorite) ? 1 : 0;
                case "select":
                    const id = item.Player.$.id;
                    const sceneIds = this.selection.selected.map((sceneId) => String(sceneId));
                    return sceneIds.includes(id) ? "1" : "0";
                case "items":
                    return item.Player?.Data[0]?.Scene[0]?.Players[0]?.Player?.length;
                case "type":
                    return item.Player.$.mimeType;
                case "modified":
                    return item.Player.$.lastModified;
                case "id":
                    return +item.Player.$.id;
                case "label":
                    return item.Player.$[property];
                case "category":
                    return item.Player?.$?.folder;
                default: {
                    return item[property];
                }
            }
        };

        if (this.activeSort) {
            const sortState: Sort = this.activeSort;
            this.sort.active = this.activeSort.active;
            this.sort.direction = this.activeSort.direction;
            this.sort.sortChange.emit(sortState);
            // this.cdr.detectChanges();
            // this.sort.sort((this.activeSort) as MatSortable);
        }
        if (this.dataSource) {
            this.dataSourcePreviewList$ = this.dataSource.connect();
        }
    }

    createBlankScene() {
        this.activeModal.close();
        const sceneId = _.uniqueId();
        const sceneBlock = this.storeSelector.getBlockLabelByFileType("scene");
        const scene: ISceneBlock = sceneBlock.template;
        const newScene = { Player: scene };

        // set scene layout
        newScene.Player.$.id = sceneId;
        newScene.Player.$.player = sceneBlock.id;
        newScene.Player.Data[0].Layout[0].$.width = this.newSceneSettings.width + "";
        newScene.Player.Data[0].Layout[0].$.height = this.newSceneSettings.height + "";
        newScene.Player.$.label = this.newSceneSettings.name;
        newScene.Player.$.mimeType = SceneMimeTypes.Player;
        this.createScene(newScene);
    }

    openBlankSceneDialog() {
        this.activeModal.close();
        this.activeModal = this.dialog.open(this.addBlackScene);
    }

    openCreateSceneDialog() {
        this.activeModal = this.dialog.open(this.createSceneModal, {
            width: "90vw",
            maxWidth: "1000px",
            minHeight: "400px",
            panelClass: "create-scene-dialog",
        });
    }

    openAISceneWizard() {
        if (Lib.IsFreeAccount(this.m_user)) {
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.UPGRADE_TO_USE_FEATURE);
            return;
        }
        // if (isGalaxy()){
        //     this.toastr.info('feature coming soon...');
        //     return;
        // }
        this.activeModal.close();
        const dialogRef = this.dialog.open(AiSceneWizardComponent, {
            width: "800px",
            data: {},
        });
        dialogRef.afterClosed().subscribe(async (result) => {
            if (result && result.scene && result.scheduleConfig) {
                // Scheduler scene: create schedule + events in DB, bind to scene block
                const sc = result.scheduleConfig;
                this.toastr.info(`Creating schedule "${sc.name}"...`);
                try {
                    // Step 1: Create the schedule record
                    const newScheduleId = await this.commonService.addSchedule({
                        schedule_name: sc.name,
                        description: sc.description || ''
                    });

                    if (newScheduleId && Array.isArray(sc.events) && sc.events.length > 0) {
                        // Step 2: Create schedule events
                        const failedEvents = [];
                        for (const evt of sc.events) {
                            const saveRecord: any = {
                                studioId: this.localStoreService.getStorageConfig().studioId,
                                command: 'add',
                                primary: 'schedule_event_id',
                                table: 'schedule_events',
                                body: {
                                    schedule_id: newScheduleId,
                                    event_name: evt.event_name || 'Scheduled Content',
                                    repeat_type: evt.repeat_type ?? 5,
                                    time: evt.time ?? 32400,
                                    duration: evt.duration ?? 28800,
                                    weekly_days: evt.weekly_days ?? 0,
                                    repeat_forever: evt.repeat_forever ?? 1,
                                    enabled: evt.enabled ?? '1',
                                    event_value: null,
                                },
                                id: null
                            };
                            const crudReply: any = await this.appService.crudRecord(saveRecord);
                            if (crudReply?.serverReply?.status) {
                                const newEventId = crudReply.serverReply.id;
                                this.storeSelector.dispatch(actionAddScheduleEvent({
                                    data: [{
                                        schedule_event_id: newEventId,
                                        schedule_id: newScheduleId,
                                        event_name: evt.event_name || 'Scheduled Content',
                                        repeat_type: evt.repeat_type ?? 5,
                                        time: evt.time ?? 32400,
                                        duration: evt.duration ?? 28800,
                                        weekly_days: evt.weekly_days ?? 0,
                                        repeat_forever: evt.repeat_forever ?? 1,
                                        enabled: evt.enabled ?? '1',
                                    }]
                                }));
                            } else {
                                failedEvents.push(evt.event_name || 'Unknown');
                            }
                        }

                        if (failedEvents.length > 0) {
                            this.toastr.warning(`Some schedule events could not be created: ${failedEvents.join(', ')}`);
                        }

                        // Step 3: Bind the schedule_id to the scheduler block in the AI scene
                        if (result.scene?.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player) {
                            const players = result.scene.Player.Data[0].Scene[0].Players[0].Player;
                            for (const player of players) {
                                if (player?.$?.player === '4104' && player?.Data?.[0]?.Schedule?.[0]?.$) {
                                    player.Data[0].Schedule[0].$.id = newScheduleId;
                                }
                            }
                        }
                    }

                    // Step 4: Reassign all component IDs to avoid conflicts
                    preProcessSceneTree(result.scene, _.uniqueId('__'));

                    // Step 5: Create the AI scene with bound scheduler block
                    this.createScene(result.scene);
                } catch (err) {
                    console.error('Schedule creation failed, creating AI scene without binding:', err);
                    // Reassign IDs even on error path
                    preProcessSceneTree(result.scene, _.uniqueId('__'));
                    this.createScene(result.scene);
                }
            } else if (result && result.scene && result.importTemplate) {
                // Data-bound scene (weather, stocks, etc.):
                // 1. Import the template display scene as a private child
                // 2. Bind the child to the data block's Json Player[0].$.src
                // 3. Create the AI parent scene
                const t = result.importTemplate;
                this.toastr.info(`Creating scene with ${t.name}...`);
                try {
                    const childSceneId = await this.importService.importScene(
                        String(t.businessId),
                        String(t.sceneId),
                        t.name,
                        false,
                        false
                    );

                    if (childSceneId && result.scene?.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player) {
                        const players = result.scene.Player.Data[0].Scene[0].Players[0].Player;
                        for (const player of players) {
                            if (player?.Data?.[0]?.Json?.[0]?.Player?.[0]?.$) {
                                player.Data[0].Json[0].Player[0].$.src = childSceneId;
                            }
                        }
                    }

                    // Reassign all component IDs to avoid conflicts
                    preProcessSceneTree(result.scene, _.uniqueId('__'));
                    this.createScene(result.scene);
                } catch (err) {
                    console.error('Template child import failed, creating AI scene without binding:', err);
                    // Reassign IDs even on error path
                    preProcessSceneTree(result.scene, _.uniqueId('__'));
                    this.createScene(result.scene);
                }
            } else if (result && result.scene) {
                // Regular AI scene (no scheduler, no template)
                // Reassign all component IDs to avoid conflicts
                preProcessSceneTree(result.scene, _.uniqueId('__'));
                this.createScene(result.scene);
            }
        });
    }

    addWizard() {
        this.activeModal.close();
        const dialogRef = this.dialog.open(SceneCreateWizardComponent, {
            width: "1200px",
            data: {},
        });
        dialogRef.afterClosed().subscribe((newScene) => {
            if (newScene) {
                this.createScene(newScene);
            }
        });
    }

    openTemplateBrowser() {
        this.activeModal.close();
        const dialogRef = this.dialog.open(DialogSceneCardBrowserComponent, {
            width: "95vw",
            height: "90vh",
            maxWidth: "1600px",
            data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result?.template && result?.scene) {
                // Create the scene using the generated scene data
                this.toastr.info(`Creating scene from template "${result.template.name}"...`);
                this.createScene(result.scene);
            }
        });
    }

    addSceneFromTemplate() {
        this.activeModal.close();
        this.router.navigate([`/editor/new`]);
    }

    createScene(newScene) {
        // console.log('═══════════════════════════════════════════════════════════');
        // console.log('[Scene List Details] ▶ createScene() called');
        // console.log('═══════════════════════════════════════════════════════════');
        // console.log('[Scene List Details] 📋 Received scene object:');
        // console.log(JSON.stringify(newScene, null, 2));

        // console.log('[Scene List Details] ▶ Calling preprocessSceneRecord()...');
        // console.log('[Scene List Details]    studioId:', this.localStoreService.getStorageConfig().studioId);
        // console.log('[Scene List Details]    command: "add"');

        /** CRUD create the new scene **/
        let saveRecord;
        try {
            saveRecord = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, "add");
            // console.log('[Scene List Details] ✓ preprocessSceneRecord() succeeded');
            // console.log('[Scene List Details] 📋 Save record:');
            // console.log(JSON.stringify(saveRecord, null, 2));
        } catch (preprocessError) {
            // console.error('[Scene List Details] ✗ ERROR in preprocessSceneRecord():');
            // console.error(preprocessError);
            this.toastr.error("Failed to prepare scene for saving: " + preprocessError.message);
            return;
        }

        // console.log('[Scene List Details] ▶ Calling appService.crudRecord()...');

        /** create scene and get inserted id */
        this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            // console.log('[Scene List Details] ◀ crudRecord() response received:');
            // console.log(JSON.stringify(i_crudReply, null, 2));

            if (!i_crudReply.serverReply.status) {
                // console.error('[Scene List Details] ✗ Server returned status = false');
                this.toastr.error(this.translocoService.translate("toast.failedCreateScene", {}, this.translocoService.getActiveLang()));
                return;
            }

            // console.log('[Scene List Details] ✓ Scene created successfully!');
            // console.log('[Scene List Details]    New scene ID:', i_crudReply.serverReply.id);
            // console.log('[Scene List Details]    Changelist ID:', i_crudReply.serverReply.changelist_id);

            // change scene player id
            const newPlayerId = String(i_crudReply.serverReply.id);
            newScene.Player.$.id = newPlayerId;
            newScene.Player.$.lastModified = new Date().getTime();
            newScene.Player.$.changelist_id = String(i_crudReply.serverReply.changelist_id);
            this.storeSelector.dispatch(actionAddScene({ player: newScene }));

            const saveRecord2 = preprocessSceneRecord(newScene, null, this.localStoreService.getStorageConfig().studioId, "add");
            this.crudScene("update", newPlayerId, { player_data_value: saveRecord2.body.player_data_value });
            this.router.navigateByUrl(`editor/scene/${newPlayerId}`);
        });
    }

    async createBlankSlider() {
        this.activeModal.close();
        const w = this.newSceneSettings.width + "";
        const h = this.newSceneSettings.height + "";
        const slideCount = this.newSceneSettings.slideCount || 1;
        this.toastr.info(this.translocoService.translate("toast.createSlider", {}, this.translocoService.getActiveLang()));

        const sceneId = _.uniqueId();
        const scene: ISceneBlock = _.cloneDeep(this.storeSelector.blockLabels.BLOCKCODE_SCENE.template);
        const newScene = { Player: scene };

        // set scene layout
        newScene.Player.$.id = sceneId;
        newScene.Player.Data[0].Layout[0].$.width = w;
        newScene.Player.Data[0].Layout[0].$.height = h;
        newScene.Player.$.label = this.newSceneSettings.name;
        newScene.Player.$.mimeType = SceneMimeTypes.Slides;

        const newSceneId = await this.importService.importPrebuiltScene(newScene);

        // Create multiple slides with delays
        const pages = [];
        const subSceneIds = [];

        for (let i = 0; i < slideCount; i++) {
            // Add delay between slide creations to prevent system slowdown
            if (i > 0) {
                await new Promise((resolve) => setTimeout(resolve, 300));
            }

            const newSlideName = TouchLib.uniqueName("slide");

            // create sub-scene with a label
            const { scene: newSubScene, sceneId: subSceneId } = TouchLib.createNewSlideScene(w, h, this.storeSelector.blockLabels, newSlideName, `${this.newSceneSettings.name} ${i + 1}`);
            const newSubSceneId = await this.importService.importPrebuiltScene(newSubScene, null, true);

            // Store the first sub-scene ID for navigation
            if (i === 0) {
                subSceneIds.push(newSubSceneId);
            }

            // Add page to the collection
            pages.push({
                $: {
                    page: newSubScene.Player.$.label,
                    type: "scene",
                },
                Player: [
                    {
                        $: {
                            src: newSubSceneId,
                        },
                    },
                ],
            });
        }

        // create new playlist with all pages
        const playlistBlockData: ISceneBlock = _.cloneDeep(this.storeSelector.blockLabels.COLLECTION.template);
        playlistBlockData.Data[0].Layout[0].$.x = "0";
        playlistBlockData.Data[0].Layout[0].$.y = "0";
        playlistBlockData.Data[0].Layout[0].$.height = h;
        playlistBlockData.Data[0].Layout[0].$.width = w;
        playlistBlockData.$.id = _.uniqueId("__");
        playlistBlockData.Data[0].Collection[0].Page = pages;
        playlistBlockData.Data[0].Collection[0].$.useHotkeys = "1";

        this.storeSelector.dispatch(
            actionAddSceneItem({
                sceneId: newSceneId,
                sceneItemId: newSceneId,
                values: [
                    {
                        key: "Player",
                        cloneValue: true,
                        value: playlistBlockData,
                        storePath: "Data[0].Scene[0].Players[0]",
                    },
                ],
            }),
        );

        setTimeout(() => {
            // update server scene with new scene id
            this.appService.updateMultiScene([newSceneId]);
            this.storeSelector.dispatch(actionSelectedSceneId({ id: subSceneIds[0] }));
            this.storeSelector.dispatch(actionSelectedSceneTouchId(TouchLib.createSelectedSliderPayload(newSceneId, this.newSceneSettings.name, subSceneIds[0])));
            this.router.navigateByUrl(`editor/touch/scene/${newSceneId}`);
        }, 100);
    }

    openNewSliderDialog() {
        this.activeModal.close();
        this.newSceneSettings.name = "new slide";
        this.newSceneSettings.slideCount = 3;
        this.activeModal = this.dialog.open(this.addSliderModal);
    }

    onSlideCountChange(count: number) {
        this.newSceneSettings.slideCount = count;
    }

    onDelete() {
        // if (!this.accessConfig.del) return this.accessService.showNoAccess();
        if (this.selection.selected.length === 0) return this.toastr.error(this.translocoService.translate("toast.noSceneRemSel", {}, this.translocoService.getActiveLang()));
        const localRemText1 = this.translocoService.translate("general.removeScenes2", {}, this.translocoService.getActiveLang());
        const localRemText2 = this.translocoService.translate("general.scenes", {}, this.translocoService.getActiveLang());

        // check if the scene is assigned to player.
        const isPlayerAssignedScene = this.checkScenesUsedInPlayer();
        if (isPlayerAssignedScene) {
            this.dialog.open(DialogPopComponent, {
                height: "333px",
                width: "400px",
                data: {
                    name: this.translocoService.translate("toast.notAllowedToRemoveAssignedScene", {}, this.translocoService.getActiveLang()),
                    showCancel: false,
                },
            });
        } else {
            const dialogRef = this.dialog.open(DialogPopComponent, {
                height: "333px",
                width: "400px",
                data: {
                    name: `${localRemText1} [ ${this.selection.selected.length} ] ${localRemText2}?`,
                    showCancel: true,
                },
            });
            dialogRef.afterClosed().subscribe((r) => {
                if (r) {
                    // this.removeScenesUsedInLocationScenes('GPS');
                    // this.removeScenesUsedInLocationScenes('Fixed');
                    // this.removeScenesUsedInPlaylistScenes();

                    this.removeScenesUsedInScenes();
                    this.removeScenesUsedInScheduler();
                    this.removeScenes(true);
                    this.resetSelection();
                }
            });
        }
    }

    private checkScenesUsedInPlayer(): boolean {
        let isAssigned = false;
        this.selection.selected.forEach((sceneId) => {
            if (isAssigned) return;
            if (this.m_stations.find((e) => e.props.player_data_id == sceneId)) {
                isAssigned = true;
            }
        });
        return isAssigned;
    }

    private removeScenesUsedInScenes() {
        const updatedSceneIds: Id[] = [];
        const scenes: IPlayerProps[] = this.getScenes();

        this.selection.selected.forEach((sceneId) => {
            const searchResourceResult: ISceneTreeSearchResult[] = getPlayerIdsOfSceneId(scenes, String(sceneId));

            searchResourceResult.forEach((v) => {
                let updated = false;

                if (v.lastPlaylistId) {
                    const sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastPlaylistId);
                    this.removeScenesInPlaylist(sceneData, String(sceneId));
                    updated = true;
                }
                if (v.lastLocationId) {
                    const sceneData = getPlayerIdInScene(scenes, v.sceneId, v.lastLocationId);
                    this.removeScenesInLocation(sceneData, String(sceneId), "GPS");
                    this.removeScenesInLocation(sceneData, String(sceneId), "Fixed");
                    updated = true;
                }

                if (!v.lastPlaylistId && !v.lastLocationId && v.o?.id) {
                    this.storeSelector.dispatch(
                        actionRemoveSceneBlocks({
                            sceneId: v.sceneId,
                            sceneItemId: null,
                            values: [
                                {
                                    key: null,
                                    value: v.o.id,
                                    storePath: "Data[0].Scene[0].Players[0].Player",
                                },
                            ],
                        }),
                    );
                    updated = true;
                }

                if (updated) {
                    if (updatedSceneIds.indexOf(String(v.sceneId)) === -1) {
                        updatedSceneIds.push(String(v.sceneId));
                    }
                }
            });
        });

        // save changes
        this.appService.updateMultiScene(updatedSceneIds);
    }

    private removeScenesUsedInScheduler() {
        /** remove scene schedule event */
        const sceneIds = this.selection.selected.map((sceneId) => String(sceneId));
        this.commonService.removeScheduleEventsBySources("scene", sceneIds);
    }

    // private removePrivateChildScenes() {
    //     let privateChildIds = [];
    //     this.selection.selected.forEach((_sceneId) => {
    //         this.storeSelector.listenPrivateChildPlayersOfScene(_sceneId).subscribe((_players: IPlayerProp[]) => {
    //             privateChildIds = privateChildIds.concat(_players.map((_player) => _player.$.src));
    //         }).unsubscribe();
    //     });

    //     if (privateChildIds.length > 0) {
    //         this.storeSelector.dispatch(actionRemoveScenes({
    //             sceneIds: privateChildIds
    //         }));
    //         this.crudScene('delete', privateChildIds, null);
    //     }
    // }

    confirmDuplicate() {
        if (this.loading || this.selection.selected.length > 1) {
            return;
        }

        const msg = this.translocoService.translate("message.sureDuplicate", {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: "260px",
            width: "400px",
            data: { name: msg, showCancel: true },
            // data: {name: `${msg} ${this.selection.selected.length}`, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                this.processDuplicate(this.selection.selected[0]);
            }
        });
    }

    async processDuplicate(selectedSceneId) {
        if (this.loading) return;
        this.loading = true;
        this.toastr.info(this.translocoService.translate("toast.duplicateSlide", {}, this.translocoService.getActiveLang()));

        const newScene = _.cloneDeep(this.scenes.find((i_scene) => i_scene.Player.$.id === selectedSceneId));
        const newSceneId = await this.importService.importPrebuiltScene(newScene, `${newScene.Player.$.label} | Copy`);

        // Update category and access key of new scene
        this.crudScene("update", newSceneId, {
            tree_path: newScene.Player.$.folder,
            access_key: newScene.Player.$.accessKey,
        });

        if (isMainTouchScene(newScene)) {
            const currentPages = TouchLib.getCurrentPages(newScene);
            const childSceneIds = currentPages.map((_page) => _page.Player[0].$.src);

            this.cod(
                this.storeSelector
                    .listenMultiSceneData(childSceneIds)
                    .pipe(take(1))
                    .subscribe(async (childScenes) => {
                        this.duplicateTouch(newScene, childScenes);
                    }),
            );
        } else {
            this.appService.updateMultiScene([newSceneId]);
            this.toastr.info("duplicated new scene with id is " + newSceneId);

            // Use single timeout to prevent race conditions
            setTimeout(() => {
                this.loading = false;
            }, 700);
        }
    }

    async duplicateTouch(newScene, childScenes) {
        const newSceneId = newScene.Player.$.id;
        const duplicatedChildScenes = await this.duplicateChildScenes(childScenes);
        const playlistId = TouchLib.getPlaylistId(newScene);
        const newPages = duplicatedChildScenes.map((v) => {
            return TouchLib.createPlaylistPage(v.newLabel, v.newId);
        });

        const componentName = TouchLib.getComponentName(newScene);

        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: newSceneId,
                sceneItemId: playlistId,
                values: [
                    {
                        key: "Page",
                        cloneValue: true,
                        value: newPages,
                        storePath: `Data[0].${componentName}[0]`,
                    },
                ],
            }),
        );

        this.appService.updateMultiScene([newSceneId]);
        this.toastr.info("duplicated new scene with id is " + newSceneId);

        // Use single timeout to prevent race conditions
        setTimeout(() => {
            this.loading = false;
        }, 700);
    }

    async duplicateChildScenes(childScenes) {
        const results = await Promise.all(
            childScenes.map(async (childScene) => {
                const newScene = _.cloneDeep(childScene);
                const newChildSceneId = await this.importService.importPrebuiltScene(newScene, TouchLib.uniqueName("slide"), true);
                return {
                    newId: newChildSceneId,
                    newLabel: newScene.Player.$.label,
                };
            }),
        );
        return results;
    }

    private resetSelection() {
        this.selection.clear();
    }

    private removeScenes(deletePrivateChild) {
        let removeSceneIds = this.selection.selected;
        if (deletePrivateChild) {
            // get ids of private child items
            let privateChildIds = [];
            this.selection.selected.forEach((_sceneId) => {
                this.storeSelector
                    .listenPrivateChildPlayersOfScene(_sceneId)
                    .subscribe((_players: ISceneBlock[]) => {
                        privateChildIds = privateChildIds.concat(_players.map((_player) => _player.$.src));
                    })
                    .unsubscribe();
            });
            removeSceneIds = removeSceneIds.concat(privateChildIds);
        }

        this.storeSelector.dispatch(
            actionRemoveScenes({
                sceneIds: removeSceneIds,
            }),
        );
        this.crudScene("delete", removeSceneIds, null);
    }

    private removeScenesInPlaylist(playerSceneData: ISceneTreeSliceResults, sceneId: Id) {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        _.remove(components.Playlist[0].Page, (v: IPage) => {
            if (v.$.type !== "scene") return;
            return v.Player[0].$.src === sceneId;
        });
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: playerSceneData.sceneId,
                sceneItemId: playerSceneData.sceneItem.$.id,
                values: [
                    {
                        key: "Page",
                        value: components.Playlist[0].Page,
                        storePath: `Data[0].Playlist[0]`,
                    },
                ],
            }),
        );
        this.storeSelector.dispatch({ type: "BREAK_MERGE" });
    }

    private removeScenesInLocation(playerSceneData: ISceneTreeSliceResults, sceneId: Id, slice: "GPS" | "Fixed") {
        const components: ICommon = _.cloneDeep(playerSceneData.sceneItem.Data["0"]);
        _.remove(components.LocationBased[0][slice][0].Page, (v: IPager) => {
            if (_.isEmpty(v)) return true;
            if (v.$.type !== "scene") return false;
            return v.Player[0].$.src === sceneId;
        });
        const storePath = `Data[0].LocationBased[0][${slice}][0]`;
        const value = components.LocationBased[0][slice][0]["Page"];
        this.storeSelector.dispatch(
            actionUpdateSceneItem({
                sceneId: playerSceneData.sceneId,
                sceneItemId: playerSceneData.sceneItem.$.id,
                values: [
                    {
                        key: "Page",
                        value,
                        storePath,
                    },
                ],
            }),
        );
        this.storeSelector.dispatch({ type: "BREAK_MERGE" });
    }

    private getScenes(): IPlayerProps[] {
        let scenes: IPlayerProps[] = [];
        this.cod(
            this.storeSelector.getScenes().subscribe((i_scenes) => {
                scenes = i_scenes;
            }),
        );
        return scenes;
    }

    private getStations(): IPlayerProps[] {
        let scenes: IPlayerProps[] = [];
        this.cod(
            this.storeSelector.getScenes().subscribe((i_scenes) => {
                scenes = i_scenes;
            }),
        );
        return scenes;
    }

    private getSceneCategories() {
        this.cod(
            this.storeSelector.getScenes(true).subscribe((i_scenes) => {
                this.categories = [];
                i_scenes.forEach((s, idx) => {
                    if (s.Player.$.folder) {
                        this.categories.push(s.Player.$.folder);
                    }
                });
                this.categories = this.categories.reduce((x, y) => (x.includes(y) ? x : [...x, y]), []).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                this.containerService.setCategories(this.categories);
            }),
        );
    }

    onSelectScene(sceneId) {
        const selectedScene = this.dataSource.data.find((row) => row.Player.$.id == sceneId);
        this.onSelectedRow(selectedScene);
    }

    /** clear global filter */
    clearSelection() {
        this.globalFilter = "";
        this.applyFilter("");
        this.getSceneCategories();
    }

    onChangePagination(e: PageEvent) {
        if (!e) return;
        this.pageIndex = e.pageIndex;
        if (this.selectedTabIndex === 0) {
            this.pageSize = e.pageSize;
        }
    }

    sortData(e) {
        this.activeSort = e;
    }

    private customFilterPredicate() {
        const myFilterPredicate = (data: any, filter: string): boolean => {
            if (this.showFavoritesOnly && !isTruthy(data.Player.$.favorite)) {
                return false;
            }

            let globalMatch = !this.globalFilter;

            if (this.globalFilter) {
                // search all fields
                globalMatch = (data.Player.$.label + "").toString().toLowerCase().indexOf(this.globalFilter.trim().toLowerCase()) !== -1;
            }

            if (!globalMatch) {
                return false;
            }

            const filterObj = JSON.parse(filter);
            let isFilter = true;
            // tslint:disable-next-line
            for (const col in filterObj) {
                let colData = data[col];
                if (col == "tree_path") {
                    colData = data.Player.$?.folder;
                }
                if (typeof colData !== "undefined" && colData.toString().toLowerCase().indexOf(filterObj[col].trim().toLowerCase()) == -1) {
                    isFilter = false;
                    break;
                }
            }
            return isFilter;
        };
        return myFilterPredicate;
    }

    private crudScene(command: ICRUDCommand, id, body) {
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command,
            primary: "player_data_id",
            table: "player_data",
            body,
            id,
        };
        this.storeSelector.dispatch(actionCRUDRecord({ saveRecord }));
    }

    clipboardOpenDialog() {
        if (Lib.IsAccessBlocked(this.m_user)) {
            return this.toastr.error(this.translocoService.translate("account.screenDisruption", {}, this.translocoService.getActiveLang()), "[ Contact live chat ]");
        }
        if (!this.m_user.enterprise) {
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.UPGRADE_TO_USE_FEATURE);
            return;
        }
        const dialogRef = this.dialog.open(DialogClipboardComponent, {
            width: "700px",
            data: { scenes: this.selection },
        });
        // this.cod(
        //     dialogRef.afterClosed()
        //         .pipe(take(1))
        //         .subscribe((dialogGetAsset: IDialogGetAsset) => {
        //         })
        // );
    }

    /**
     * Check if a scene is a slider wrapper scene (for icon display)
     * @param scene The scene to check
     * @returns true if the scene is a slider wrapper scene
     */
    isSliderScene(scene: IPlayerProps): boolean {
        return isMainTouchScene(scene);
    }

    /**
     * Get the number of slides in a slider scene
     * @param scene The scene to check
     * @returns The number of slides, or the number of items for non-slider scenes
     */
    @Memoizee({})
    getItemCount(scene: IPlayerProps): number {
        // If it's not a slider scene, return the regular player count
        if (scene.Player?.$.mimeType !== SceneMimeTypes.Slides) {
            return scene.Player?.Data?.[0]?.Scene?.[0]?.Players?.[0]?.Player?.length || 0;
        }

        // For slider scenes, use TouchLib to get the slide count
        return TouchLib.getPagesLength(scene) || 0;
    }

    /**
     * If scene is touch mimetype, get first child slide scene id for preview
     * Else, return scene id
     * @param row
     * @returns
     */
    @Memoizee({})
    getPreviewSceneId(row) {
        if (row.Player.$.mimeType === SceneMimeTypes.Slides) {
            return TouchLib.getFirstSlideSceneId(row);
        }
        return row.Player.$.id;
    }

    /**
     * Get scene layout dimensions (wrapper scene size)
     * @param row
     * @returns
     */
    @Memoizee({})
    getSceneDimensions(row) {
        if (!row?.Player?.Data?.[0]?.Layout?.[0]?.$) {
            return "N/A";
        }
        const layout = row.Player.Data[0].Layout[0].$;
        const width = layout.width || "N/A";
        const height = layout.height || "N/A";
        return `${width}x${height}`;
    }

    onDetailsRow(event, scene) {
        this.selection.toggle(scene.Player.$.id);
        event.stopPropagation();
    }

    isFavorite(scene: IPlayerProps): boolean {
        return isTruthy(scene?.Player?.$?.favorite);
    }

    onFavorite(event, scene: IPlayerProps) {
        event.stopPropagation();
        const sceneId = scene.Player.$.id;
        const clonedScene = _.cloneDeep(scene);
        clonedScene.Player.$.favorite = isTruthy(scene.Player.$.favorite) ? "false" : "true";
        this.storeSelector.dispatch(actionUpdateScenePlayer({ sceneId, playerData: clonedScene.Player }));
        const saveRecord = preprocessSceneRecord(clonedScene, sceneId, this.localStoreService.getStorageConfig().studioId, "update");
        this.crudScene("update", sceneId, { player_data_value: saveRecord.body.player_data_value });
    }

    onToggleFavoriteFilter() {
        this.showFavoritesOnly = !this.showFavoritesOnly;
        this.localStoreService.setStorageValConfig("sceneFavoritesOnly", String(this.showFavoritesOnly));
        if (this.dataSource) {
            this.dataSource.filter = JSON.stringify(this.columnFilter);
        }
    }

    /**
     * Handle row selection - navigate to touch editor for sliders, regular editor for others
     * @param row The selected scene row
     */
    onSelectedRow(row: IPlayerProps) {
        if (isSceneEmbedded(row)) return this.toastr.error(this.translocoService.translate("toast.embeddedScenesNo", {}, this.translocoService.getActiveLang()));

        // Handle dialog asset selection mode
        if (this.dialogGetAsset) {
            this.itemSelected.emit(Number(row.Player.$.id));
            return;
        }

        // Check if this is a slider scene and navigate accordingly
        if (this.isSliderScene(row)) {
            // Navigate to touch editor (same logic as touch-list-details)
            const firstChildSceneId = TouchLib.getFirstSlideSceneId(row);
            this.storeSelector.dispatch(actionSelectedSceneId({ id: firstChildSceneId }));
            this.storeSelector.dispatch(actionSelectedSceneTouchId(TouchLib.createSelectedSliderPayload(row.Player.$.id, row.Player.$.label, firstChildSceneId)));
            this.router.navigateByUrl(`/editor/touch/scene/${row.Player.$.id}`);
        } else {
            // Navigate to regular scene editor
            this.storeSelector.dispatch(actionSelectedSceneId({ id: row.Player.$.id }));
            this.router.navigateByUrl(`/editor/list/${row.Player.$.id}`);
        }
    }

    toggleListView(tabChangeEvent: MatTabChangeEvent) {
        this.selectedTabIndex = tabChangeEvent.index;
        if (this.selectedTabIndex === 0) {
            this.hidePageSize = false;
            this.paginator._changePageSize(this.pageSize);
        } else {
            this.hidePageSize = true;
            this.paginator._changePageSize(10);
        }
    }

    /**
     * Get total scene count
     */
    getSceneCount(): number {
        return this.scenes?.length || 0;
    }

    /**
     * Get regular scene count
     */
    getRegularSceneCount(): number {
        if (!this.scenes) return 0;
        return this.scenes.filter((scene) => (this.storeSelector.isMainSceneOrPlayer(scene.Player.$.mimeType) || scene.Player.$.mimeType.length === 0) && !isMainTouchScene(scene)).length;
    }

    /**
     * Get specialized scene count
     */
    getSpecializedSceneCount(): number {
        if (!this.scenes) return 0;
        return this.scenes.filter(
            (scene) => scene.Player?.$?.mimeType?.length > 0 && scene.Player.$.mimeType !== SceneMimeTypes.Player && scene.Player.$.mimeType !== SceneMimeTypes.Scene && scene.Player.$.mimeType !== SceneMimeTypes.Slides,
        ).length;
    }

    /**
     * Get slides scene count
     */
    getSlidesSceneCount(): number {
        if (!this.scenes) return 0;
        return this.scenes.filter((scene) => isMainTouchScene(scene)).length;
    }

    /**
     * Get relative time from timestamp
     * @param timestamp Unix timestamp in milliseconds
     * @returns Relative time string
     */
    getRelativeTime(timestamp: string): string {
        if (!timestamp) return "";
        const now = new Date().getTime();
        const then = parseInt(timestamp);
        const diff = now - then;

        const seconds = Math.floor(diff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        if (years > 0) return `${years}y ago`;
        if (months > 0) return `${months}mo ago`;
        if (days > 0) return `${days}d ago`;
        if (hours > 0) return `${hours}h ago`;
        if (minutes > 0) return `${minutes}m ago`;
        return "just now";
    }

    override destroy() {
        this.onDeselect();
        this.containerService.setTableSelection("scenes", {
            // selectedModel: this.selection.selected,
            sort: this.activeSort,
            pageIndex: this.pageIndex,
        });
        this.containerService.setMarkedTableRow(null);
    }
}
